import { getService } from './service';

export const getAddressDetails = (ptsAddressID) => {
  const service = getService('ptsaddress');
  return service.find({ query: { ptsAddressID } });
}